export type CategoryType = 'maternal' | 'nuclear' | 'other' | 'paternal';

export const FAMILY_HISTORY_RELATIONSHIP_MAP: Record<
  string,
  { code: string; display: string; text: string; category: CategoryType }
> = {
  // PATERNAL
  FTH: { code: 'FTH', display: 'father', text: 'Father', category: 'paternal' },
  NFTHF: {
    code: 'NFTHF',
    display: 'natural father of fetus',
    text: 'Natural Father of Fetus',
    category: 'paternal',
  },
  NFTH: {
    code: 'NFTH',
    display: 'natural father',
    text: 'Natural Father',
    category: 'paternal',
  },
  PAUNT: {
    code: 'PAUNT',
    display: 'paternal aunt',
    text: 'Paternal Aunt',
    category: 'paternal',
  },
  PCOUSN: {
    code: 'PCOUSN',
    display: 'paternal cousin',
    text: 'Paternal Cousin',
    category: 'paternal',
  },
  PGRFTH: {
    code: 'PGRFTH',
    display: 'paternal grandfather',
    text: 'Paternal Grandfather',
    category: 'paternal',
  },
  PGRMTH: {
    code: 'PGRMTH',
    display: 'paternal grandmother',
    text: 'Paternal Grandmother',
    category: 'paternal',
  },
  PGRPRN: {
    code: 'PGRPRN',
    display: 'paternal grandparent',
    text: 'Paternal Grandparent',
    category: 'paternal',
  },
  PGGRFTH: {
    code: 'PGGRFTH',
    display: 'paternal great-grandfather',
    text: 'Paternal Great-Grandfather',
    category: 'paternal',
  },
  PGGRMTH: {
    code: 'PGGRMTH',
    display: 'paternal great-grandmother',
    text: 'Paternal Great-Grandmother',
    category: 'paternal',
  },
  PGGRPRN: {
    code: 'PGGRPRN',
    display: 'paternal great-grandparent',
    text: 'Paternal Great-Grandparent',
    category: 'paternal',
  },
  PUNCLE: {
    code: 'PUNCLE',
    display: 'paternal uncle',
    text: 'Paternal Uncle',
    category: 'paternal',
  },

  // MATERNAL
  GESTM: {
    code: 'GESTM',
    display: 'gestational mother',
    text: 'Gestational Mother',
    category: 'maternal',
  },
  MAUNT: {
    code: 'MAUNT',
    display: 'maternal aunt',
    text: 'Maternal Aunt',
    category: 'maternal',
  },
  MCOUSN: {
    code: 'MCOUSN',
    display: 'maternal cousin',
    text: 'Maternal Cousin',
    category: 'maternal',
  },
  MGRFTH: {
    code: 'MGRFTH',
    display: 'maternal grandfather',
    text: 'Maternal Grandfather',
    category: 'maternal',
  },
  MGRMTH: {
    code: 'MGRMTH',
    display: 'maternal grandmother',
    text: 'Maternal Grandmother',
    category: 'maternal',
  },
  MGRPRN: {
    code: 'MGRPRN',
    display: 'maternal grandparent',
    text: 'Maternal Grandparent',
    category: 'maternal',
  },
  MGGRFTH: {
    code: 'MGGRFTH',
    display: 'maternal great-grandfather',
    text: 'Maternal Great-Grandfather',
    category: 'maternal',
  },
  MGGRMTH: {
    code: 'MGGRMTH',
    display: 'maternal great-grandmother',
    text: 'Maternal Great-Grandmother',
    category: 'maternal',
  },
  MGGRPRN: {
    code: 'MGGRPRN',
    display: 'maternal great-grandparent',
    text: 'Maternal Great-Grandparent',
    category: 'maternal',
  },
  MUNCLE: {
    code: 'MUNCLE',
    display: 'maternal uncle',
    text: 'Maternal Uncle',
    category: 'maternal',
  },
  MTH: { code: 'MTH', display: 'mother', text: 'Mother', category: 'maternal' },
  NMTH: {
    code: 'NMTH',
    display: 'natural mother',
    text: 'Natural Mother',
    category: 'maternal',
  },
  NMTHF: {
    code: 'NMTHF',
    display: 'natural mother of fetus',
    text: 'Natural Mother of Fetus',
    category: 'maternal',
  },

  // NUCLEAR
  BRO: {
    code: 'BRO',
    display: 'brother',
    text: 'Brother',
    category: 'nuclear',
  },
  CHILD: {
    code: 'CHILD',
    display: 'child',
    text: 'Child',
    category: 'nuclear',
  },
  DAUC: {
    code: 'DAUC',
    display: 'daughter',
    text: 'Daughter',
    category: 'nuclear',
  },
  DOMPART: {
    code: 'DOMPART',
    display: 'domestic partner',
    text: 'Domestic Partner',
    category: 'nuclear',
  },
  FMRSPS: {
    code: 'FMRSPS',
    display: 'former spouse',
    text: 'Former Spouse',
    category: 'nuclear',
  },
  FTWIN: {
    code: 'FTWIN',
    display: 'fraternal twin',
    text: 'Fraternal Twin',
    category: 'nuclear',
  },
  FTWINBRO: {
    code: 'FTWINBRO',
    display: 'fraternal twin brother',
    text: 'Fraternal Twin Brother',
    category: 'nuclear',
  },
  FTWINSIS: {
    code: 'FTWINSIS',
    display: 'fraternal twin sister',
    text: 'Fraternal Twin Sister',
    category: 'nuclear',
  },
  HBRO: {
    code: 'HBRO',
    display: 'half-brother',
    text: 'Half-Brother',
    category: 'nuclear',
  },
  HSIB: {
    code: 'HSIB',
    display: 'half-sibling',
    text: 'Half-Sibling',
    category: 'nuclear',
  },
  HSIS: {
    code: 'HSIS',
    display: 'half-sister',
    text: 'Half-Sister',
    category: 'nuclear',
  },
  HUSB: {
    code: 'HUSB',
    display: 'husband',
    text: 'Husband',
    category: 'nuclear',
  },
  ITWIN: {
    code: 'ITWIN',
    display: 'identical twin',
    text: 'Identical Twin',
    category: 'nuclear',
  },
  ITWINBRO: {
    code: 'ITWINBRO',
    display: 'identical twin brother',
    text: 'Identical Twin Brother',
    category: 'nuclear',
  },
  ITWINSIS: {
    code: 'ITWINSIS',
    display: 'identical twin sister',
    text: 'Identical Twin Sister',
    category: 'nuclear',
  },
  NBRO: {
    code: 'NBRO',
    display: 'natural brother',
    text: 'Natural Brother',
    category: 'nuclear',
  },
  NCHILD: {
    code: 'NCHILD',
    display: 'natural child',
    text: 'Natural Child',
    category: 'nuclear',
  },
  DAU: {
    code: 'DAU',
    display: 'natural daughter',
    text: 'Natural Daughter',
    category: 'nuclear',
  },
  NPRN: {
    code: 'NPRN',
    display: 'natural parent',
    text: 'Natural Parent',
    category: 'nuclear',
  },
  NSIB: {
    code: 'NSIB',
    display: 'natural sibling',
    text: 'Natural Sibling',
    category: 'nuclear',
  },
  NSIS: {
    code: 'NSIS',
    display: 'natural sister',
    text: 'Natural Sister',
    category: 'nuclear',
  },
  SON: {
    code: 'SON',
    display: 'natural son',
    text: 'Natural Son',
    category: 'nuclear',
  },
  PRN: { code: 'PRN', display: 'parent', text: 'Parent', category: 'nuclear' },
  SIB: {
    code: 'SIB',
    display: 'sibling',
    text: 'Sibling',
    category: 'nuclear',
  },
  SIGOTHR: {
    code: 'SIGOTHR',
    display: 'significant other',
    text: 'Significant Other',
    category: 'nuclear',
  },
  SIS: { code: 'SIS', display: 'sister', text: 'Sister', category: 'nuclear' },
  SONC: { code: 'SONC', display: 'son', text: 'Son', category: 'nuclear' },
  SPS: { code: 'SPS', display: 'spouse', text: 'Spouse', category: 'nuclear' },
  TWIN: { code: 'TWIN', display: 'twin', text: 'Twin', category: 'nuclear' },
  TWINBRO: {
    code: 'TWINBRO',
    display: 'twin brother',
    text: 'Twin Brother',
    category: 'nuclear',
  },
  TWINSIS: {
    code: 'TWINSIS',
    display: 'twin sister',
    text: 'Twin Sister',
    category: 'nuclear',
  },
  WIFE: { code: 'WIFE', display: 'wife', text: 'Wife', category: 'nuclear' },

  // OTHER
  CHLDADOPT: {
    code: 'CHLDADOPT',
    display: 'adopted child',
    text: 'Adopted Child',
    category: 'other',
  },
  DAUADOPT: {
    code: 'DAUADOPT',
    display: 'adopted daughter',
    text: 'Adopted Daughter',
    category: 'other',
  },
  ADOPTF: {
    code: 'ADOPTF',
    display: 'adoptive father',
    text: 'Adoptive Father',
    category: 'other',
  },
  ADOPTM: {
    code: 'ADOPTM',
    display: 'adoptive mother',
    text: 'Adoptive Mother',
    category: 'other',
  },
  ADOPTP: {
    code: 'ADOPTP',
    display: 'adoptive parent',
    text: 'Adoptive Parent',
    category: 'other',
  },
  SONADOPT: {
    code: 'SONADOPT',
    display: 'adopted son',
    text: 'Adopted Son',
    category: 'other',
  },
  AUNT: { code: 'AUNT', display: 'aunt', text: 'Aunt', category: 'other' },
  BROINLAW: {
    code: 'BROINLAW',
    display: 'brother-in-law',
    text: 'Brother-In-Law',
    category: 'other',
  },
  CHLDINLAW: {
    code: 'CHLDINLAW',
    display: 'child-in-law',
    text: 'Child-In-Law',
    category: 'other',
  },
  COUSN: {
    code: 'COUSN',
    display: 'cousin',
    text: 'Cousin',
    category: 'other',
  },
  DAUINLAW: {
    code: 'DAUINLAW',
    display: 'daughter in-law',
    text: 'Daughter-In-Law',
    category: 'other',
  },
  EXT: {
    code: ' EXT',
    display: 'extended family member',
    text: 'Extended Family Member',
    category: 'other',
  },
  FAMMEMB: {
    code: ' FAMMEMB',
    display: 'family member',
    text: 'Family Member',
    category: 'other',
  },
  FTHINLAW: {
    code: 'FTHINLAW',
    display: 'father-in-law',
    text: 'Father-In-Law',
    category: 'other',
  },
  CHLDFOST: {
    code: 'CHLDFOST',
    display: 'foster child',
    text: 'Foster Child',
    category: 'other',
  },
  DAUFOST: {
    code: 'DAUFOST',
    display: 'foster daughter',
    text: 'Foster Daughter',
    category: 'other',
  },
  FTHFOST: {
    code: 'FTHFOST',
    display: 'foster father',
    text: 'Foster Father',
    category: 'other',
  },
  MTHFOST: {
    code: 'MTHFOST',
    display: 'foster mother',
    text: 'Foster Mother',
    category: 'other',
  },
  PRNFOST: {
    code: 'PRNFOST',
    display: 'foster parent',
    text: 'Foster Parent',
    category: 'other',
  },
  SONFOST: {
    code: 'SONFOST',
    display: 'foster son',
    text: 'Foster Son',
    category: 'other',
  },
  GRNDCHILD: {
    code: 'GRNDCHILD',
    display: 'grandchild',
    text: 'Grandchild',
    category: 'other',
  },
  GRNDDAU: {
    code: 'GRNDDAU',
    display: 'granddaughter',
    text: 'Granddaughter',
    category: 'other',
  },
  GRFTH: {
    code: 'GRFTH',
    display: 'grandfather',
    text: 'Grandfather',
    category: 'other',
  },
  GRMTH: {
    code: 'GRMTH',
    display: 'grandmother',
    text: 'Grandmother',
    category: 'other',
  },
  GRPRN: {
    code: 'GRPRN',
    display: 'grandparent',
    text: 'Grandparent',
    category: 'other',
  },
  GRNDSON: {
    code: 'GRNDSON',
    display: 'grandson',
    text: 'Grandson',
    category: 'other',
  },
  GGRFTH: {
    code: 'GGRFTH',
    display: 'great grandfather',
    text: 'Great Grandfather',
    category: 'other',
  },
  GGRMTH: {
    code: 'GGRMTH',
    display: 'great grandmother',
    text: 'Great Grandmother',
    category: 'other',
  },
  GGRPRN: {
    code: 'GGRPRN',
    display: 'great grandparent',
    text: 'Great Grandparent',
    category: 'other',
  },
  INLAW: { code: 'INLAW', display: 'inlaw', text: 'In-Law', category: 'other' },
  MTHINLAW: {
    code: 'MTHINLAW',
    display: 'mother-in-law',
    text: 'Mother-In-Law',
    category: 'other',
  },
  NIENEPH: {
    code: 'NIENEPH',
    display: 'niece/nephew',
    text: 'Niece/Nephew',
    category: 'other',
  },
  NEPHEW: {
    code: 'NEPHEW',
    display: 'nephew',
    text: 'Nephew',
    category: 'other',
  },
  NIECE: { code: 'NIECE', display: 'niece', text: 'Niece', category: 'other' },
  PRNINLAW: {
    code: 'PRNINLAW',
    display: 'parent in-law',
    text: 'Parent-In-Law',
    category: 'other',
  },
  SIBINLAW: {
    code: 'SIBINLAW',
    display: 'sibling in-law',
    text: 'Sibling-In-Law',
    category: 'other',
  },
  SISINLAW: {
    code: 'SISINLAW',
    display: 'sister-in-law',
    text: 'Sister-In-Law',
    category: 'other',
  },
  SONINLAW: {
    code: 'SONINLAW',
    display: 'son in-law',
    text: 'Son-In-Law',
    category: 'other',
  },
  STPBRO: {
    code: 'STPBRO',
    display: 'step brother',
    text: 'Stepbrother',
    category: 'other',
  },
  STPCHLD: {
    code: 'STPCHLD',
    display: 'step child',
    text: 'Step Child',
    category: 'other',
  },
  STPDAU: {
    code: 'STPDAU',
    display: 'stepdaughter',
    text: 'Stepdaughter',
    category: 'other',
  },
  STPFTH: {
    code: 'STPFTH',
    display: 'stepfather',
    text: 'Stepfather',
    category: 'other',
  },
  STPMTH: {
    code: 'STPMTH',
    display: 'stepmother',
    text: 'Stepmother',
    category: 'other',
  },
  STPPRN: {
    code: 'STPPRN',
    display: 'step parent',
    text: 'Step Parent',
    category: 'other',
  },
  STPSIB: {
    code: 'STPSIB',
    display: 'Step Sibling',
    text: 'Step Sibling',
    category: 'other',
  },
  STPSIS: {
    code: 'STPSIS',
    display: 'step sister',
    text: 'Stepsister',
    category: 'other',
  },
  STPSON: {
    code: 'STPSON',
    display: 'stepson',
    text: 'Stepson',
    category: 'other',
  },
  UNCLE: { code: 'UNCLE', display: 'uncle', text: 'Uncle', category: 'other' },
};

export const FAMILY_HISTORY_RELATIONSHIP_OPTIONS = Object.values(
  FAMILY_HISTORY_RELATIONSHIP_MAP
);

export const SORTED_FAMILY_RELATIONSHIP_OPTIONS =
  FAMILY_HISTORY_RELATIONSHIP_OPTIONS.sort(
    ({ category: categoryA }, { category: categoryB }) =>
      categoryA.localeCompare(categoryB)
  );
